import React from 'react';
import { get, map } from 'lodash';
import classnames from 'classnames';
import { Icon } from 'modules/icon-bank';
import { entityInfoCells as EntityInfoCells } from 'ui/views/widgets/entityInfoCells';

// local dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { getLabel } from 'utils/getLabel';

// DetailSummaryAction
const DetailSummaryAction = ( props ) => {

    // action item class name
    const widgetClassName = classnames( 'ui-table__body__data__row__primary__cell__actions__item', {
        'ui-table__body__data__row__primary__cell__actions__item--disabled': ! props.isActive,
    } );

    // get `hideIfDisabled` from action config
    // const hideIfDisabled = get( props, 'action.config.hideIfDisabled', false );

    // return null if action is not active and `hideIfDisabled`: true
    if( ! props.isActive ) {
        return null;
    }

    return (
        <div className={ widgetClassName } onClick={ () => props.onActionClick( { type: 'headAction', value: props.action } ) }>
            <div className='ui-table__body__data__row__primary__cell__actions__item__icon'>
                <Icon
                    name={ props.iconName }
                    width={ 16 }
                    height={ 16 }
                    fill={ props.isActive ? THEME.themeColorPrimary2 : '#7a7a7a' }
                />
            </div>

            <div className='ui-table__body__data__row__primary__cell__actions__item__title'>
                { getLabel( props.action.title ) }
            </div>
        </div>
    );
};

// set display name
DetailSummaryAction.displayName = '_memberPrescriptionDetailSummary.DetailSummaryAction';

/***************************************** */


const NAV_ACTION_ICON = {
    'toDos': 'checkedContent',
    'refill': 'cart',
    'renew': 'renew',
    enableAuto: 'enable',
    disableAuto: 'disable'
};


const _memberPrescriptionDetailSummary = ( props ) => {

    // get the widget title
    const widgetTitle = get( props, 'componentData.widgetConfig.title', [] );

    // nav actions
    const navActions = get( props, 'componentData.navActions', {} );

    const fields = get( props, 'componentData.fields', [] );
    const sections = get( props, 'componentData.sections', [] );
    const rxData = get( props, 'componentData.rxData', [] );

    return (
        <div className='ui-member-prescription-detail-summary'>
            
            <div className='ui-member-prescription-detail-summary__header'>
                <div className='ui-member-prescription-detail-summary__header__title'>
                    { getLabel( widgetTitle ) }
                </div>

                <div className='ui-member-prescription-detail-summary__header__actions'>
                    { map( navActions, action => {

                        // get if the action is active or not
                        const isActive = get( rxData, `actionVisibility.${ action.visibility }`, false );

                        // get action icon
                        const iconName = NAV_ACTION_ICON[ `${ action.name }` ];

                        return (
                            <DetailSummaryAction
                                key={ action.name }
                                action={ action }
                                isActive={ isActive }
                                iconName={ iconName }
                                onActionClick={ props.onActionClick }
                            />
                        );

                    } ) }
                </div>

            </div>

            <div className='ui-member-prescription-detail-summary__body'>
                <div className='ui-member-prescription-detail-summary__body__fields'>

                    {/* view to render order details */}
                    <EntityInfoCells
                        items= { fields }
                        values={ rxData.values }
                        actionsVisibility = { get( rxData, 'actionVisibility', [] ) }
                        onActionClick={ props.onActionClick }
                        className='ui-member-prescription-detail-summary__body__fields__cell'
                    />

                </div>

                <div className='ui-member-prescription-detail-summary__body__sections'>

                    { map( sections, section => {

                        // get value for each section
                        const value = get( rxData, `${section.type}`, {} );

                        return (
                            <div key={ section.type } className='ui-member-prescription-detail-summary__body__sections__section'>
                                <div className='ui-member-prescription-detail-summary__body__sections__section__icon'>
                                    <Icon id={ 'patientInfo' === section.type ? 'patient': 'doctor' } />
                                </div>
                                <div className='ui-member-prescription-detail-summary__body__sections__section__info'>
                                    <EntityInfoCells
                                        items= { section.fields }
                                        values={ value }
                                        actionsVisibility = { props, 'componentData.section', [] .actionsVisibility }
                                        onActionClick={ props.onActionClick }
                                        className='ui-member-prescription-detail-summary__body__sections__section__info__cell'
                                    />
                                </div>
                            </div>
                        );
                    } ) }

                </div>
                
            </div>
            
        </div>
    );
};

// set display name
_memberPrescriptionDetailSummary.displayName = 'memberPrescriptionDetailSummary';

// set default props
_memberPrescriptionDetailSummary.defaultProps = {};

// prop types
_memberPrescriptionDetailSummary.propTypes = {};

/********************************* */


const memberPrescriptionDetailSummaryPreloader = ( ) => {
   
    return (
        <div className='ui-member-prescription-detail-summary-preloader'>
            <div className='ui-member-prescription-detail-summary-preloader__header'>
                <div className='ui-member-prescription-detail-summary-preloader__header__title'></div>
                <div className='ui-member-prescription-detail-summary-preloader__header__actions'>
                    { map( [ 1, 2, 3 ], item => {
                        return (
                            <div className='ui-member-prescription-detail-summary-preloader__header__actions__action' key={ item } ></div>
                        );
                    } ) }
                </div>
            </div>
            <div className='ui-member-prescription-detail-summary-preloader__body'>
                { map( [ 1, 2 ], item => {
                    return (
                        <div className='ui-member-prescription-detail-summary-preloader__body__primary' key={ item }>
                            { map( [ 1, 2, 3, 4, 5, 6 ], _item => {
                                return (
                                    <div  className='ui-member-prescription-detail-summary-preloader__body__primary__cell' key={ _item }>
                                        <div className='ui-member-prescription-detail-summary-preloader__body__primary__cell__title'></div>
                                        <div className='ui-member-prescription-detail-summary-preloader__body__primary__cell__value'></div>
                                    </div>
                                );
                            } ) }
                        </div>
                    );
                } ) }
            </div>
        </div>
    );
};

// set display name
memberPrescriptionDetailSummaryPreloader.displayName = 'memberPrescriptionDetailSummaryPreloader';

// set default props
memberPrescriptionDetailSummaryPreloader.defaultProps = {};

// prop types
memberPrescriptionDetailSummaryPreloader.propTypes = {};

/***************************** */

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberPrescriptionDetailSummary as MemberPrescriptionDetailSummary } from 'ui/views/widgets/memberPrescriptionDetailSummary';
 *
 * // render
 * <MemberPrescriptionDetailSummary propName='propValue'/>
 */
export const memberPrescriptionDetailSummary = withNetworkState( memberPrescriptionDetailSummaryPreloader, _memberPrescriptionDetailSummary );
